import React from 'react';
import { Alert } from 'react-bootstrap';

/**
 * Form-level error and success alerts. Renders nothing if both are empty.
 * @param {string} [error] - Error message
 * @param {string} [success] - Success message
 */
const FormAlerts = ({ error, success }) => (
  <>
    {error && <Alert variant="danger">{error}</Alert>}
    {success && <Alert variant="success">{success}</Alert>}
  </>
);

export default FormAlerts;
